export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Peru-2d4f5547de1da2c8544a19b5de28a4e8.mp3";